export type SbcHousehold = {
  livingSituation: string /* SLR_HAUSHALT_LEBENSSITUATION */
  kidsUnderEighteen: number /* SLR_HAUSHALT_KINDERU18 */
  kidsOverEighteen: number /* SLR_HAUSHALT_KINDERO18 */
  avmParent0: string /* SLR_HAUSHALT_AVM_PARENT0 */
  avmParent1: string | null /* SLR_HAUSHALT_AVM_PARENT1 */
  avmKidUnderEighteen0: string | null /* SLR_HAUSHALT_AVM_UNDERAGE0 */
  avmKidUnderEighteen1: string | null /* SLR_HAUSHALT_AVM_UNDERAGE1 */
  avmKidUnderEighteen2: string | null /* SLR_HAUSHALT_AVM_UNDERAGE2 */
  avmKidUnderEighteen3: string | null /* SLR_HAUSHALT_AVM_UNDERAGE3 */
  avmKidUnderEighteen4: string | null /* SLR_HAUSHALT_AVM_UNDERAGE4 */
  avmKidUnderEighteen5: string | null /* SLR_HAUSHALT_AVM_UNDERAGE5 */
  avmKidUnderEighteen6: string | null /* SLR_HAUSHALT_AVM_UNDERAGE6 */
  avmKidUnderEighteen7: string | null /* SLR_HAUSHALT_AVM_UNDERAGE7 */
  avmKidUnderEighteen8: string | null /* SLR_HAUSHALT_AVM_UNDERAGE8 */
  avmKidUnderEighteen9: string | null /* SLR_HAUSHALT_AVM_UNDERAGE9 */
  avmKidOverEighteen0: string | null /* SLR_HAUSHALT_AVM_FULLAGE0 */
  avmKidOverEighteen1: string | null /* SLR_HAUSHALT_AVM_FULLAGE1 */
  avmKidOverEighteen2: string | null /* SLR_HAUSHALT_AVM_FULLAGE2 */
  avmKidOverEighteen3: string | null /* SLR_HAUSHALT_AVM_FULLAGE3 */
  avmKidOverEighteen4: string | null /* SLR_HAUSHALT_AVM_FULLAGE4 */
  avmKidOverEighteen5: string | null /* SLR_HAUSHALT_AVM_FULLAGE5 */
  avmKidOverEighteen6: string | null /* SLR_HAUSHALT_AVM_FULLAGE6 */
  avmKidOverEighteen7: string | null /* SLR_HAUSHALT_AVM_FULLAGE7 */
  avmKidOverEighteen8: string | null /* SLR_HAUSHALT_AVM_FULLAGE8 */
  avmKidOverEighteen9: string | null /* SLR_HAUSHALT_AVM_FULLAGE9 */
  livingSituationJanuaryFirst: string /* SLR_HAUSHALT_WOHNSITZ1JAN */
  min5YearsInBasel: string /* SLR_HAUSHALT_MIND5JAHRINBASEL */
}

export const LIVING_SITUATION_COUPLE = 'couple'
export const LIVING_SITUATION_SINGLE_WITH_CHILD = 'single_with_child'
export const LIVING_SITUATION_SINGLE_WITHOUT_CHILD = 'single_without_child'

export type SbcAlimony = {
  alimonyObtained: string | null /* SLR_ALIMENTE_ALIMENTE */
  alimonyObtainedAmount: number | null /* SLR_ALIMENTE_HOEHEALIMENTE */
  alimonyUnpaid: string | null /* SLR_ALIMENTE_UNTERHALT */
  alimonyUnpaidAmount0: number | null /* SLR_ALIMENTE_HOEHEUNTERHALT0 */
  alimonyUnpaidAmount1: number | null /* SLR_ALIMENTE_HOEHEUNTERHALT1 */
  alimonyUnpaidAmount2: number | null /* SLR_ALIMENTE_HOEHEUNTERHALT2 */
  alimonyUnpaidAmount3: number | null /* SLR_ALIMENTE_HOEHEUNTERHALT3 */
  alimonyUnpaidAmount4: number | null /* SLR_ALIMENTE_HOEHEUNTERHALT4 */
  alimonyUnpaidAmount5: number | null /* SLR_ALIMENTE_HOEHEUNTERHALT5 */
  alimonyUnpaidAmount6: number | null /* SLR_ALIMENTE_HOEHEUNTERHALT6 */
  alimonyUnpaidAmount7: number | null /* SLR_ALIMENTE_HOEHEUNTERHALT7 */
  alimonyUnpaidAmount8: number | null /* SLR_ALIMENTE_HOEHEUNTERHALT8 */
  alimonyUnpaidAmount9: number | null /* SLR_ALIMENTE_HOEHEUNTERHALT9 */
}

export type SbcHousing = {
  familyRentalContributions: string | null /* SLR_WOHNSITUATION_FMZBEITRAEGE */
  familyRentalContributionsAmount:
    | number
    | null /* SLR_WOHNSITUATION_HOEHEFMZBEITRAEGE */
  rentedFlat: string | null /* SLR_WOHNSITUATION_MIETWOHNUNG */
  rentalCosts: number | null /* SLR_WOHNSITUATION_HOEHEMIETE */
  numberOfRooms: number | null /* SLR_WOHNSITUATION_ANZAHLZIMMER */
}

export type SbcIncome = {
  incomeAdults: number /* SLR_EINKUENFTE_HOEHEEINKOMMEN */
  incomeAdultsBetween18And25:
    | number
    | null /* SLR_EINKUENFTE_HOEHEEINKOMMEN1825 */
  additionalBenefits: string /* SLR_EINKUENFTE_ERGAENZUNGEN */
  additionalBenefitsAmount: number | null /* SLR_EINKUENFTE_HOEHEERGAENZUNGEN */
  incomeInsurance: string /* SLR_EINKUENFTE_EINKUENFTEVERSICHERUNG */
  incomeInsuranceAmount:
    | number
    | null /* SLR_EINKUENFTE_HOEHEEINKUENFTEVERSICHERUNG */
  otherIncome: string /* SLR_EINKUENFTE_EINKUENFTEUNTERHALT */
  otherIncomeAmount: number | null /* SLR_EINKUENFTE_HOEHEEINKUENFTEUNTERHALT */
  realEstate: string /* SLR_EINKUENFTE_EINKUENFTELIEGENSCHAFTEN */
  realEstateAmount:
    | number
    | null /* SLR_EINKUENFTE_HOEHEEINKUENFTELIEGENSCHAFTEN */
}

export type SbcDeductions = {
  paidAlimony: string /* SLR_ABZUEGE_UNTERHALT */
  paidAlimonyAmount: number | null /* SLR_ABZUEGE_HOEHEUNTERHALT */
  secondPillar: string /* SLR_ABZUEGE_SAEULE2 */
  thirdPillar: string /* SLR_ABZUEGE_SAEULE3 */
  thirdPillarAmount: number | null /* SLR_ABZUEGE_HOEHESAEULE3 */
}

export type SbcAssets = {
  privateAssets: number /* SLR_VERMOEGEN_HOEHEVERMOEGEN */
  realEstateTaxBase: number | null /* SLR_VERMOEGEN_HOEHESTEUERWERT */
}

/* form SLR-Haushalt (7 steps) */
export type SocialBenefitCalculator = {
  sbcHousehold: SbcHousehold /* form step 1:Haushalt */
  sbcAlimony: SbcAlimony /* form step 2: Alimente */
  sbcHousing: SbcHousing /* form step 3: Wohnsituation */
  sbcIncome: SbcIncome /* form step 4: Einkünfte */
  sbcDeductions: SbcDeductions /* form step 5: Abzüge */
  sbcAssets: SbcAssets /* form step 6: Vermögen */
}

export enum Knockout {
  PV_RESIDENCE_NOT_IN_BASEL = 'PV_RESIDENCE_NOT_IN_BASEL' /* PV_WOHNSITZ_NICHT_IN_BS */,
  PV_INCOME_TOO_HIGH = 'PV_INCOME_TOO_HIGH' /* PV_EINKOMMEN_ZU_HOCH */,
  ABV_INCOME_TOO_HIGH = 'ABV_INCOME_TOO_HIGH' /* ABV_EINKOMMEN_ZU_HOCH */,
  ABV_ALREADY_RECEIVED_FROM_ABV = 'ABV_ALREADY_RECEIVED_FROM_ABV' /* ABV_BEREITS_BEZUG_VON_ABV */,
  ABV_NO_CHILD_UNDER_25 = 'ABV_NO_CHILD_UNDER_25' /* ABV_KEINE_KINDER_U25 */,
  ABV_UNPAID_ALIMONY = 'ABV_UNPAID_ALIMONY' /* ABV_UNBEZAHLTE_ALIMENTE */,
  MIVO_TOO_SMALL_RENT = 'MIVO_TOO_SMALL_RENT' /* MIVO_ZU_GERINGER_MIETZINS */,
  MIVO_INCOME_TOO_HIGH = 'MIVO_INCOME_TOO_HIGH' /* MIVO_EINKOMMEN_ZU_HOCH */,
  MIVO_PARENT_AT_LEAST_5_YEARS = 'MIVO_PARENT_AT_LEAST_5_YEARS' /* MIVO_ELTERNTEIL_MIN_FUENF_JAHRE */,
  MIVO_NO_CHILD = 'MIVO_NO_CHILD' /* MIVO_KEINE_KINDER */,
  MIVO_ALREADY_RECEIVED_FROM_MIVO = 'MIVO_ALREADY_RECEIVED_FROM_MIVO' /* MIVO_BEREITS_BEZUG_VON_MIVO */,
  MIVO_NO_RENTED_FLAT = 'MIVO_NO_RENTED_FLAT' /* MIVO_KEINE_MIETWOHNUNG */,
  MIVO_FLAT_TOO_BIG = 'MIVO_FLAT_TOO_BIG' /* MIVO_WOHNUNG_ZU_GROSS */,
  SHC_CURRENTLY_IN_INITIAL_EDUCATION = 'SHC_CURRENTLY_IN_INITIAL_EDUCATION' /* SHR_AKTUELL_IN_ERSTAUSBILDUNG */,
  SHC_RESIDENCE_IN_BASEL = 'SHC_RESIDENCE_IN_BASEL' /* SHR_WOHNSITZ_IN_BS_SH */,
  SHC_ASSETS_TOO_HIGH = 'SHC_ASSETS_TOO_HIGH' /* SHR_VERMOEGEN_ZU_HOCH */,
  SHC_NEED_FOR_SMALL_INCOME = 'SHC_NEED_FOR_SMALL_INCOME' /* SHR_BEDARF_KLEINER_EINKOMMEN */,
  SCC_RESIDENCE_NOT_IN_BASEL = 'SCC_RESIDENCE_NOT_IN_BASEL' /* ABLEHNUNG_GRUND_AP_PV_KEIN_WOHNSITZ_IN_BS */,
  SCC_NO_CHILD = 'SCC_NO_CHILD' /* ABLEHNUNG_GRUND_AP_MIVO_KEINE_KINDER */,
  SCC_ALIMONY_NO_CHILD = 'SCC_ALIMONY_NO_CHILD' /* ABLEHNUNG_GRUND_AP_ABV_KEINE_KINDER */,
  SCC_ASSET_TOO_HIGH = 'SCC_ASSET_TOO_HIGH' /* ABLEHNUNG_GRUND_AP_SH_VERMOEGEN_ZU_HOCH */,
  SCC_NO_PENSION = 'SCC_NO_PENSION' /* ABLEHNUNG_GRUND_AP_EL_KEINE_RENTE */,
  SCC_DAY_CARE_NO_CHILD = 'SCC_DAY_CARE_NO_CHILD' /* ABLEHNUNG_GRUND_AP_TB_KEIN_KIND */,
  SCC_NO_ONGOING_EDUCATION = 'SCC_NO_ONGOING_EDUCATION' /* ABLEHNUNG_GRUND_AP_ABB_KEINE_AUSBILDUNG */,
}

export type ClaimResult = {
  reasons: Knockout[]
  amount: number | null
}

export type SocialBenefitCalculatorResult = {
  sbcPv: ClaimResult
  sbcAbv: ClaimResult
  sbcMiVo: ClaimResult
}

export function isTrue(yesNoOption: string | null | undefined): boolean {
  if (yesNoOption == null) {
    return false
  }
  if (yesNoOption !== 'undefined') {
    return yesNoOption === 'yes'
  } else {
    return false
  }
}

export type ShcLiving = {
  livingInBasel: string /* SHR_WOHNEN_WOHNENINBS */
}

export type ShcHousehold = {
  householdSize: string /* SHR_HAUSHALT_ANZAHLPERSONEN */
  ageCategory: string | null /* SHR_HAUSHALT_ALTER */
  initialEducationFinished: string | null /* SHR_HAUSHALT_ERSTAUSBILDUNG */
  initialEducationOngoing:
    | string
    | null /* SHR_HAUSHALT_ERSTAUSBILDUNGAKTUELL */
  livingSituation: string | null /* SHR_HAUSHALT_ZUSAMMENLEBEN */
  kidsUnder18: number | null /* SHR_HAUSHALT_ANZAHLKINDER */
  kidsOver18:
    | number
    | null /* SHR_HAUSHALT_ANZAHLERWACHSENE = "shrHaushalt.setWeiterePersonen" */
}

export const HOUSEHOLD_SIZE_ONE = 'one_person'
export const HOUSEHOLD_SIZE_SEVERAL = 'two_persons_or_more'

export const AGE_CATEGORY_18_TO_25 = 'age_cat_18_25'
export const AGE_CATEGORY_OVER_26 = 'age_cat_over_26'

// export const LIVING_SITUATION_COUPLE = 'couple' => already defined above
// export const LIVING_SITUATION_COHABITATION = 'cohabitation' => not used in the code but redefined in the FormKit Element
export const LIVING_SITUATION_ALONE = 'alone'

export type ShcAssetsIncome = {
  assetAmount: number /* SHR_EINKOMMEN_VERMOEGEN */
  income: string /* SHR_EINKOMMEN_EINKOMMEN */
  incomeAmount: number | null /* SHR_EINKOMMEN_HOEHEEINKOMMEN */
  incomePartnerAmount: number | null /* SHR_EINKOMMEN_PARTNERHOEHEEINKOMMEN */
  incomeKidsAmount: number | null /* SHR_EINKOMMEN_KINDHOEHEEINKOMMEN */
}

export type ShcExpenses = {
  rentalCosts: number /* SHR_AUSGABEN_MIETE */
  additionalCosts: number /* SHR_AUSGABEN_NEBENKOSTEN */
  healthInsurance: number /* SHR_AUSGABEN_KRANKENKASSE */
  externalCare: string | null /* SHR_AUSGABEN_FREMDBETREUUNG */
  externalCareAmount: number | null /* SHR_AUSGABEN_HOEHEFREMDBETREUUNG */
}

/* form SHR-Wohnen (5 steps) */
export type SocialHelpCalculator = {
  shcLiving: ShcLiving /* form step 1: Wohnen */
  shcHousehold: ShcHousehold /* form step 2: Haushalt */
  shcAssetsIncome: ShcAssetsIncome /* form step 3: Vermögen und Einkommen */
  shcExpenses: ShcExpenses /* form step 4: Ausgaben */
}

export type SocialHelpCalculatorResult = {
  shcClaim: ClaimResult
}

/* form Anspruch (2 steps) */
export type SccInput = {
  livingInBasel: string /* AP_WOHNSITZINBS */
  ahvOrIvPension: string /* AP_AHVIVRENTNERIN */
  someoneInEducation: string /* AP_HHMITGLIEDINAUSBILDUNG */
  kidsUnderEighteen: string /* AP_KINDERUNTER18 */
  kidsInInitialEducation: string /* AP_KINDERINERSTAUSBILDUNG */
  assetSmallerThan: string /* AP_VERMOEGENKLEINERALS */
}
export type SocialClaimCalculator = {
  sccInput: SccInput
}

export type SocialClaimCalculatorResult = {
  premiumReduction: Knockout[]
  familyRentContributions: Knockout[]
  alimonyAdvance: Knockout[]
  socialHelp: Knockout[]
  complementaryBenefits: Knockout[]
  dayCare: Knockout[]
  trainingContributions: Knockout[]
}
